import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav/Nav';
import MoreDetailsModal from '../components/MyUploads/MoreDetailsModal';
import { Button } from '@material-tailwind/react';
import Footer from '../components/Footer/Footer';

export default function MyUploads() {
  const [uploaded, setUploaded] = useState([]);
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);
  const [shownUpload, setShownUpload] = useState({})

  useEffect(() => {
    getUploaded();
    const interval = setInterval(() => {
      getUploaded();
    }, 120000);
    return () => clearInterval(interval);
  }, []);

  async function getUploaded() {
    const response = await fetch("https://uploads.jellyo.net/api/upload/uploaded", { credentials: 'include' });
    const responseData = await response.json();
    setUploaded(responseData.uploaded);
  }

  function handleRefresh() {
    // setUploaded([]);
    getUploaded();
  }
  
  function handleOpenMoreDetails(upload) {
    setShownUpload(upload);
    upload.isNewUpload = false;
    setMoreDetailsOpen(true);
  }

  function getSecondsLeft(date1, date2 = new Date()) {
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);

    const earlierDate = firstDate < secondDate ? firstDate : secondDate;
    const laterDate = firstDate < secondDate ? secondDate : firstDate;
    const differenceInSeconds = Math.round((laterDate - earlierDate) / 1000); // Convert milliseconds to seconds
    return differenceInSeconds;
  }

  function formatTime(seconds) {
    const secondsInAMinute = 60;
    const secondsInAnHour = 3600;
    const secondsInADay = 86400;
    const secondsInAWeek = 604800;
  
    if (seconds >= secondsInAWeek) {
      const weeks = (seconds / secondsInAWeek).toFixed(0);
      return `${weeks} week${weeks > 1 ? 's' : ''}`;
    } else if (seconds >= secondsInADay) {
      const days = (seconds / secondsInADay).toFixed(0);
      return `${days} day${days > 1 ? 's' : ''}`;
    } else if (seconds >= secondsInAnHour) {
      const hours = (seconds / secondsInAnHour).toFixed(0);
      return `${hours} hour${hours > 1 ? 's' : ''}`;
    } else if (seconds >= secondsInAMinute) {
      const minutes = (seconds / secondsInAMinute).toFixed(0);
      return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    } else {
      return `${seconds} second${seconds > 1 ? 's' : ''}`;
    }
  }

  return (
    <div className={`overflow-x-hidden h-dvh w-screen bg-background-img bg-cover bg-repeat flex flex-col justify-center items-center`}>
      <Nav />

      <div className={`max-w-[80rem] w-[90%] md:min-w-[40rem] max-h-[35rem] min-h-[30rem] m-4 mt-8 p-4 bg-offwhite rounded-xl shadow-all flex flex-col`}>

        <div className='relative text-gray-900 font-medium text-center text-3xl border-b-2 pb-4 flex items-center'>
          <span>Your Uploads</span>
          <Button onClick={handleRefresh} size="sm" className='group !absolute right-0 flex w-10 h-10 rounded-full justify-center items-center bg-gray-900'>
            <i className='bx bx-refresh rounded text-2xl text-white font-thin group-hover:animate-spin'></i>
          </Button>
        </div>

        <div className={`grid grid-cols-auto-fit-minmax gap-2 overflow-y-auto my-2 px-4 sm:px-8 py-4 h-full w-full max-w-[80rem]`}>
          {uploaded.length === 0 ? <span className='mt-10 text-center text-gray-600 text-3xl'>No Uploads Found</span> : ""}
          {
            uploaded.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)).reverse().map(upload => (
              <div key={upload.uploadId} onClick={() => handleOpenMoreDetails(upload)} className="group relative p-4 text-wrap break-words h-44 w-full flex flex-col justify-center items-center rounded-lg transition-all cursor-pointer" >
                <div className='w-full h-full rounded-lg text-white opacity-0 absolute flex flex-col justify-center items-center bg-black z-10 transition-opacity duration-200 group-hover:opacity-80'>
                  <span className='w-4/5 opacity-100 mb-1 text-center text-lg'>Click to view details</span>
                </div>
                <div className='relative w-full h-full flex flex-col justify-center items-center'>
                  <i className={`${upload.type === "text" ? "" : "hidden"} bx bxs-file text-6xl group-hover:animate-vibrate`}></i>
                  <i className={`${upload.type === "files" ? "" : "hidden"} bx bxs-file-archive text-6xl group-hover:animate-vibrate`}></i>
                  <span className='w-4/5 text-center truncate text-ellipsis'>{upload.title || (upload.type === "files" ? "File Upload" : "Text Upload")}</span>
                  <span className='relative'>
                    <span className='text-gray-500'>Created {formatTime(getSecondsLeft(upload.createdAt))} ago</span>
                    <span className={`${upload.isNewUpload ? "" : "hidden"} absolute left-36 -top-20 text-sm p-1 text-white bg-red-500 rounded-lg`}>NEW!</span>
                  </span>
                </div>
              </div>
            ))
          }
        </div>

        <div className='pt-4 flex flex-col md:gap-3 md:flex-row md:items-center justify-center items-center border-t-2 text-gray-500'>
          Total Uploads: {uploaded.length}
        </div>
      </div>
      <MoreDetailsModal upload={shownUpload} getUploaded={getUploaded} open={moreDetailsOpen} setOpen={setMoreDetailsOpen} />
      <Footer />
    </div>
  )
}
